import { useMemo, useState } from "react";

// Workspace upload state bundle (ported hook — the source file wasn't in
// the kit; reconstructed from WorkspacePage.jsx usage).
export function useWorkspaceUploads() {
  const [files, setFiles] = useState([]);
  const [activeFileId, setActiveFileId] = useState(null);
  const [activePage, setActivePage] = useState(1);
  const [expandedPdfs, setExpandedPdfs] = useState(() => new Set());
  const [uploadOpen, setUploadOpen] = useState(false);
  const [pendingDeleteFile, setPendingDeleteFile] = useState(null);
  const [deletingFile, setDeletingFile] = useState(false);
  const [splittingIds, setSplittingIds] = useState(() => new Set());
  const [pinningSubpage, setPinningSubpage] = useState(null);

  const activeFile = useMemo(
    () => (files || []).find((f) => f.id === activeFileId) || null,
    [files, activeFileId],
  );

  return {
    files, setFiles,
    activeFileId, setActiveFileId,
    activeFile,
    activePage, setActivePage,
    expandedPdfs, setExpandedPdfs,
    uploadOpen, setUploadOpen,
    pendingDeleteFile, setPendingDeleteFile,
    deletingFile, setDeletingFile,
    splittingIds, setSplittingIds,
    pinningSubpage, setPinningSubpage,
  };
}
